/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Blank_OperatorInputs */

const en_legal_blank_operator = /** @type {(inputs: Legal_Blank_OperatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[company name: to be added]`)
};

const pl_legal_blank_operator = /** @type {(inputs: Legal_Blank_OperatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[nazwa firmy: do uzupełnienia]`)
};

/**
* | output |
* | --- |
* | "[company name: to be added]" |
*
* @param {Legal_Blank_OperatorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_blank_operator = /** @type {((inputs?: Legal_Blank_OperatorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Blank_OperatorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_blank_operator(inputs)
	return en_legal_blank_operator(inputs)
});